import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { memo as t } from "react";
import { Typography as a } from "./index59.mjs";
import { Box as i } from "@mui/material";
const s = t(
  ({ optionsMap: r, selected: o }) => {
    const m = r[o].flag;
    return /* @__PURE__ */ n(
      i,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          gap: 1,
          marginRight: 1
        },
        children: [
          /* @__PURE__ */ e(m, {}),
          /* @__PURE__ */ e(a.Caption, { children: r[o].shortLabel || r[o].value.toUpperCase() })
        ]
      }
    );
  }
);
export {
  s as SelectInnerRenderValue
};
//# sourceMappingURL=SelectInnerRenderValue.mjs.map
